import type { DescriptionPage_WeeklyMaterialItemType as DescriptionPageWeeklyMaterialItemType } from '__generated__/graphql-types';

import type { WeeklyMaterialItemFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';

const getGroupedAssessments = (assessments?: WeeklyMaterialItemFragment[] | null) => {
  return assessments?.reduce((groupedAssessments, assessment) => {
    const { typeName } = assessment;
    if (groupedAssessments[typeName]) {
      groupedAssessments[typeName].push(assessment);
    } else {
      groupedAssessments[typeName] = [assessment];
    }
    return groupedAssessments;
  }, {} as Record<DescriptionPageWeeklyMaterialItemType, WeeklyMaterialItemFragment[]>);
};

export default getGroupedAssessments;
